'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('$qWhen', function ($q) {
    return function (deferrals, noFail) {
      var length = deferrals.length,
          remaining = length !== 1 || deferrals && deferrals[0] && Object.prototype.toString.call(deferrals[0].promise) ? length : 0,
          deferred = remaining === 1 ? deferrals : $q.defer();
      if (length > 1) {
        var results = new Array(length);
        // 导致整个队列失败的单个deferred失败数 默认为1 即单个失败则整个列队失败
        var queueFails = noFail ? length : 1,

        // 实际deferred失败数
        fails = 0;
        var updateFunc = function updateFunc(index, type) {
          return function (result) {
            results[index] = arguments.length > 1 ? Array.prototype.slice.call(arguments) : result;
            if (type === 1) {
              fails++;
            } else if (type === 2) {
              deferred.notify(results);
            } else if (type === 0) {}
            if (! --remaining) {
              if (fails >= queueFails) {
                deferred.reject(results);
              } else {
                deferred.resolve(results);
              }
            }
          };
        };
        for (var i = 0; i < length; i++) {
          // 判断参数是不是可用的Deferred
          if (deferrals[i] && Object.prototype.toString.call(deferrals[i].promise)) {
            deferrals[i].then(
            // 单个成功则更新成功数
            updateFunc(i, 0),
            // 单个失败则整个列队失败
            updateFunc(i, 1),
            // 单个开始运行则更新运行中的个数
            updateFunc(i, 2));
          } else {
            // 不可用则未完成数减1
            --remaining;
          }
        }
      }
      if (!remaining) {
        deferred.resolve();
      }
      return deferred.promise;
    };
  });
  return app;
};

require('angular');

/**
 * 模拟jquery $.when
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/services/$qWhen.js
// module id = 146
// module chunks = 0